import { Attachment } from './attachments';
import { Warehouse } from './warehouses';

export interface ShipmentItemGroupConfiguration {
    configurationId: number
    configurationQuantity: number
    quantity: number
    partialQuantity: number
}

export enum ShipmentStage {
    Planning = 'planning',
    InProgress = 'in_progress',
    Completed = 'completed',
}

export enum ShipmentDirection {
    Inbound = 'inbound',
    Outbound = 'outbound',
}

export interface Shipment {
    id: number
    createdAt: string
    updatedAt: string
    name: string | null
    merchantId: number
    notes: string | null
    internalNotes: string | null
    attachments?: Attachment[]
    warehouseId: number
    warehouse?: Warehouse
}
